import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { SessionService } from '../services/session.service';

@Injectable()
export class AuthorizationGuard implements CanActivate {

    constructor(private sessionService: SessionService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        if (this.sessionService.isAuthenticated() ) {
            return true;
        } else {
            if(this.sessionService.checkStorageSession() == null) {
                this.router.navigate(['/login']); /// guard does not have from where to take refresh token and make call
            } else {
                return true;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/authorization.guard.ts